/* DoubleOak — landing page composition. */

import React from 'react';
import {
  LpFooter,
  LpLockup,
  LpSignup,
  LpSocials,
} from './shared-sections.jsx';
import { FeatureSections } from './feature-sections.jsx';

const FOUNDER_PERKS = [
  ['Early access',     <>In <em>first</em>.</>,        "Closed beta opens June 2026. Founders get in before the public launch."],
  ['Direct line',      <>Shape the <em>app</em>.</>,   "Your sightings and feedback drive what we build next."],
  ['Pro, free, for life', <>Free <em>forever</em>.</>, "Pro features are free for life."],
];

const FAQ_ITEMS = [
  { q: <>What's a <em>Founder</em>?</>, a: "Founders are the San Antonio whiskey hunters who join us during the closed beta. You'll test new features, share what's working, and shape the roadmap. In return, every Pro feature we ever ship stays free for you, for life." },
  { q: <>Why <em>San Antonio</em> first?</>, a: "We live here. Building it in our own backyard lets us refine the experience before opening it up to other cities. Austin and Houston are next on the list." },
  { q: <>Will the app be <em>free</em>?</>, a: "Yes. Feed, Bounties, Squads, and the Hunt Map are all free. A Pro tier with more features will come later." },
  { q: <>When does it <em>launch</em>?</>, a: "Closed beta opens June 2026 in San Antonio. Public launch follows in fall 2026, in time for allocation season. Founders get in first." },
];

export function LandingPage() {
  return (
    <div className="lp" id="lpA">
      <nav className="lp-nav" aria-label="Primary">
        <LpLockup/>
        <a className="lp-nav__cta lp-nav__cta--filled" href="#signup">
          Become a Founder <span aria-hidden="true">→</span>
        </a>
      </nav>

      {/* HERO — doubles as the recruiting pitch */}
      <section className="lp-section lp-hero" style={{paddingTop: 64, paddingBottom: 64}}>
        <div className="lp-hero__grid">
          <div className="lp-hero__copy">
            <span className="lp-eyebrow">Now accepting Founders · San Antonio</span>
            <h1 className="lp-h1" style={{margin:'22px 0 18px'}}>
              Find rare whiskey<br className="lp-h1__br-lg"/> <em>before</em> it's gone.
            </h1>
            <p className="lp-hero__dek">
              Share local whiskey sightings in your neighborhood. Starting in <em>San Antonio</em>.
            </p>

            <div id="signup" className="lp-signup-block">
              <p className="lp-signup-block__intro">
                We're looking for <em>San Antonio</em> whiskey hunters to help shape the app.
              </p>
              <LpSignup ctaLabel="Become a Founder"/>
            </div>
            <LpSocials/>
          </div>

          <aside className="lp-hero__aside" aria-labelledby="founder-card-h">
            <div className="lp-founder-card">
              <span className="lp-eyebrow" id="founder-card-h">What's a Founder?</span>
              <p className="lp-founder-card__def">
                The first San Antonio whiskey hunters in our closed beta. You shape the app. You keep <em>Pro, free, forever</em>.
              </p>
              <ol className="lp-founder-card__list">
                {FOUNDER_PERKS.map(([kicker, title, body], i) => (
                  <li key={i}>
                    <span className="lp-founder-card__num">{String(i + 1).padStart(2, '0')}</span>
                    <div>
                      <span className="lp-founder-card__kicker">{kicker}</span>
                      <h3>{title}</h3>
                      <p>{body}</p>
                    </div>
                  </li>
                ))}
              </ol>
            </div>
          </aside>
        </div>
      </section>

      <hr className="lp-rule"/>

      <FeatureSections/>

      <hr className="lp-rule"/>

      {/* FAQ */}
      <section className="lp-section" id="faq">
        <div className="lp-faq-grid">
          <div>
            <span className="lp-eyebrow">Frequently asked</span>
            <h2 className="lp-h2" style={{marginTop: 18}}>Common <em>questions</em>.</h2>
          </div>
          <div>
            {FAQ_ITEMS.map((it, i) => (
              <div key={i} className="lp-faq__row">
                <div className="num">{String(i + 1).padStart(2, '0')}</div>
                <div>
                  <h3>{it.q}</h3>
                  <p>{it.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="lp-section lp-cta-final" style={{background:'var(--do-ink-deep)', borderTop:'1px solid var(--do-rule)', borderBottom:'1px solid var(--do-rule)'}}>
        <div style={{textAlign:'center', maxWidth: 720, margin:'0 auto'}}>
          <span className="lp-eyebrow" style={{justifyContent:'center'}}>Founding Members · San Antonio</span>
          <h2 className="lp-h2 lp-h2--xl" style={{margin:'22px 0 18px'}}>Become a <em>Founder</em>.</h2>
          <p className="lp-lede" style={{margin:'0 auto 36px', textAlign:'center', maxWidth: 560}}>
            Help shape DoubleOak from day one. San Antonio only, for now.
          </p>
          <div className="lp-signup-block lp-signup-block--final">
            <LpSignup ctaLabel="Become a Founder"/>
            <p style={{margin:'14px auto 0', textAlign:'center', maxWidth: 480, fontSize:13, color:'var(--do-cream-dim)', fontFamily:'var(--do-sans)', lineHeight:1.5}}>
              Founders keep every Pro feature, free, for life. No payment now. Email is all we need.
            </p>
          </div>
          <LpSocials align="center"/>
        </div>
      </section>

      <LpFooter/>
    </div>
  );
}
